import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
import { IdeaIcon } from '@hugeicons/core-free-icons';

interface LearningEmptyStateProps {
    onSuggestTopic: () => void;
}


const LearningEmptyState = ({ onSuggestTopic }: LearningEmptyStateProps) => {
    const { palette } = useTheme();

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            spacing={2}
            sx={{
                height: '100%',
                px: 3,
                textAlign: 'center',
            }}
        >
            <Box
                sx={{
                    border: `5px solid ${palette.primary.light}`,
                    borderRadius: 2,
                    width: '128px',
                    height: '128px',
                    overflow: 'hidden'
                }}
            >
                <img
                    src={"https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2FLearning.webp?alt=media&token=2d669118-2a07-4337-b1ad-0a195eda17ce"}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
            </Box>


            <Typography
                variant="h3"
            >
                No hay tutoriales disponibles para esta página
            </Typography>

            <Typography
                variant="body1"
                color="text.secondary"
                justifyContent={"center"}
                alignItems={"center"}
            >
                Aún no hemos publicado guías en video para esta sección.
                ¿Hay algo específico que te gustaría aprender o resolver aquí?
            </Typography>

            <Button
                variant="contained"
                onClick={onSuggestTopic}
                startIcon={
                    <HugeiconsIcon
                        icon={IdeaIcon}
                        size={18}
                    />
                }
                sx={{
                    width: '100%',
                }}
            >
                Sugerir un tema
            </Button>

            <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                    mt: 1,
                    fontSize: 10,
                }}
            >
                Revisamos sugerencias semanalmente para producir nuevo material.
            </Typography>
        </Stack>
    );
};

export default LearningEmptyState;
